import axios from 'axios'
import { Commit } from 'vuex'

const url_api = process.env.VUE_APP_API_URL

export default {
    namespaced: true,
    state: {
        userStats: [],
        subCommunityStats: [],
        reflectionStats: [],
        readingPlanStats: [],
    },
    getters: {
        getUserStats: (state: { userStats: AnalyserOptions }) => state.userStats,
        getSubCommunityStats: (state: { subCommunityStats: AnalyserOptions }) => state.subCommunityStats,
        getReflectionStats: (state: { reflectionStats: AnalyserOptions }) => state.reflectionStats,
        getReadingPlanStats: (state: { readingPlanStats: AnalyserOptions }) => state.readingPlanStats
    },
    mutations: {
        SET_USER_STATS(state: { userStats: any }, payload: any) {
            state.userStats = payload
        },
        SET_SUB_COMMUNITY_STATS(state: { subCommunityStats: any }, payload: any) {
            state.subCommunityStats = payload
        },
        SET_REFLECTION_STATS(state: { reflectionStats: any }, payload: any) {
            state.reflectionStats = payload
        },
        SET_READING_PLAN_STATS(state: { readingPlanStats: any }, payload: any) {
            state.readingPlanStats = payload
        },
    },
    actions: {
        async fetchUserStats({ commit }: { commit: Commit }) {
            try {
                const response = await axios.get(url_api + "count-users-per-year", {
                    headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                    }
                });

                if (response.data.status === 200) {
                    commit('SET_USER_STATS', response.data.data)
                    return response.data.data
                } else {
                    console.error("Unexpected response:", response.data)
                }
            } catch (error) {
                console.error("Error fetching user stats:", error)
                throw error
            }
        },
        async fetchSubCommunityStats({ commit }: { commit: Commit }) {
            try {
                const response = await axios.get(url_api + "count-sub-komunitas-per-year", {
                    headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                    }
                });

                if (response.data.status === 200) {
                    commit('SET_SUB_COMMUNITY_STATS', response.data.data)
                    return response.data.data
                } else {
                    console.error("Unexpected response:", response.data)
                }
            } catch (error) {
                console.error("Error fetching user stats:", error)
                throw error
            }
        },
        async fetchReflectionStats({ commit }: { commit: Commit }) {
            try {
                const response = await axios.get(url_api + "count-renungan-per-year", {
                    headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                    }
                });

                if (response.data.status === 200) {
                    commit('SET_REFLECTION_STATS', response.data.data)
                    return response.data.data
                } else {
                    console.error("Unexpected response:", response.data)
                }
            } catch (error) {
                console.error("Error fetching user stats:", error)
                throw error
            }
        },
        async fetchReadingPlanStats({ commit }: { commit: Commit }) {
            try {
                const response = await axios.get(url_api + "count-agenda-per-year", {
                    headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                    }
                });

                if (response.data.status === 200) {
                    commit('SET_READING_PLAN_STATS', response.data.data)
                    return response.data.data
                } else {
                    console.error("Unexpected response:", response.data)
                }
            } catch (error) {
                console.error("Error fetching user stats:", error)
                throw error
            }
        }
    },
}
